import React from 'react';
import './Pagination.css';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const maxPageNumberWindow = 5;
  let startPage: number, endPage: number;

  if (totalPages <= maxPageNumberWindow) {
    // Moins de maxPageNumberWindow total pages donc montre toutes les pages
    startPage = 1;
    endPage = totalPages;
  } else {
    // Plus de maxPageNumberWindow total pages donc calcule les pages à montrer
    const maxPagesBeforeCurrentPage = Math.floor(maxPageNumberWindow / 2);
    const maxPagesAfterCurrentPage = Math.ceil(maxPageNumberWindow / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      // Proche du début; montre les premières pages
      startPage = 1;
      endPage = maxPageNumberWindow;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      // Proche de la fin; montre les dernières pages
      startPage = totalPages - maxPageNumberWindow + 1;
      endPage = totalPages;
    } else {
      // Au milieu; montre quelques pages avant et après la page actuelle
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }

  const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, idx) => startPage + idx);

  return (
    <nav className="pagination-container">
      <ul className="pagination">
        {/* Les boutons de navigation précédente */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button 
            onClick={() => onPageChange(currentPage - 1)} 
            className="page-link" 
            disabled={currentPage === 1}
          >
            {'<'}
          </button>
        </li>
        {/* Numéros de page */}
        {pageNumbers.map(number => (
          <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
            <button 
              onClick={() => onPageChange(number)} 
              className="page-link"
            >
              {number}
            </button>
          </li>
        ))}
        {/* Les boutons de navigation suivante */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button 
            onClick={() => onPageChange(currentPage + 1)} 
            className="page-link" 
            disabled={currentPage === totalPages}
          >
            {'>'}
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
